export default "__VITE_ASSET__RxmUZzWL__"